import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { RouterLink } from '@angular/router';
import { DeviceType } from '../../models/interfaces/device-type.type';
import { DeviceWidthService } from '../../services/width.service';
import { MatIconModule } from '@angular/material/icon';
import { NgIf, NgFor} from '@angular/common';
import { IomModuleService } from '../../services/iom-module.service';
import { Course } from '../../models/interfaces/course.interface';

@Component({
    selector: 'app-course-list',
    templateUrl: './course-list.component.html',
    styleUrls: ['./course-list.component.scss'],
    standalone: true,
    imports: [NgIf, RouterLink, MatIconModule, NgFor]
})
export class CourseListComponent implements OnDestroy, OnInit {

  deviceType: DeviceType = 'desktop';
  private subscription: Subscription | null = null;
  private destroy$ = new Subject<void>();
  courses: Course[] = [];

  constructor(
  private deviceWidth: DeviceWidthService,
  private readonly iom: IomModuleService,
  ) {
  }

  ngOnInit() {
    this.deviceWidth.getDeviceType$()
    .pipe(takeUntil(this.destroy$))
    .subscribe(type => {
      this.deviceType = type;
    });

    this.getAllCourses();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.subscription?.unsubscribe();
  }

  getAllCourses() {
    this.iom.getAllCourses()
      .pipe(takeUntil(this.destroy$))
      .subscribe(courses => {
        this.courses = courses;
      });
  }
}